import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import QSOPage from './pages/QSOPage';
import AnnoncesPage from './pages/AnnoncesPage';
import AgendaPage from './pages/AgendaPage';
import AuthPage from './pages/AuthPage';
import ProfilePage from './pages/ProfilePage';
import ComitePage from './pages/ComitePage';
import StammPage from './pages/StammPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ShortLinkPage from './pages/ShortLinkPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DisplayPage from './pages/DisplayPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/qso" replace />} />
            <Route path="qso" element={<QSOPage />} />
            <Route path="annonces" element={<AnnoncesPage />} />
            <Route path="stamm" element={<StammPage />} />
            <Route path="agenda" element={<AgendaPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="comite/*" element={<ComitePage />} />
          <Route path="auth" element={<AuthPage />} />
          <Route path="verify-email" element={<VerifyEmailPage />} />
          <Route path="reset-password" element={<ResetPasswordPage />} />
          <Route path="a/:token" element={<ShortLinkPage />} />
        </Route>
        <Route path="display" element={<DisplayPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
